module.exports = __webpack_public_path__ + "assets/img/field.4e0f7795.jpg";